<template>
  <div>
    <!--照片区域-->
    <input id="imgLivingUploadFile" type="file" accept="image/*" capture="user" style="float:left;display:none;" @change="imgLivingReadLocalFile" /><!-- capture="camera" -->
  </div>
</template>

<script>
import { RecordThridSpendLog } from '@/api/customer';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { mapGetters, mapMutations } from 'vuex';
import { compress } from '@/utils/compress';

export default {
  name: 'XwpImageLiveness',
  data() {
    return {
      picInfo: {
        type: '',
        base64: '',
        small64: '',
        fileUrl: '',
        webUrl: '',
        blob: '',
      },
      faceImgUrl: '',
    };
  },
  computed: {
    ...mapGetters(['livingFaceAccessToken', 'livingFaceCustomerId', 'livingFaceVerifyType']),
  },
  methods: {
    ...mapMutations(['setLivingFaceImgUrl', 'setLivingFacePopupStatus', 'setLivingFaceType']),

    // 调用接口，计费统计
    recordThridSpendLog(type, callback = null) {
      const data = {
        customerId: this.livingFaceCustomerId,
        payType: 4,
        type: type,
      };
      RecordThridSpendLog(data)
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },

    // 图片click
    imgClick(type) {
      this.picInfo.type = type;
      this.picInfo.blob = '';
      this.picInfo.base64 = '';
      this.picInfo.small64 = '';
      this.picInfo.fileUrl = '';
      this.picInfo.webUrl = '';
      document.getElementById('imgLivingUploadFile').click();
    },

    // 点击选中图片
    imgLivingReadLocalFile(e) {
      // 没有选择的时候返回、不提交
      if (!e.target.value) return;
      const that = this;
      CusLoadingOpen('压缩中...');
      // 读取文件，并加载图片
      const fileCtrl = document.getElementById('imgLivingUploadFile');
      const localFile = fileCtrl.files[0];
      const reader = new FileReader();
      reader.onload = function (event) {
        const readerData = reader.result;
        // 获取图片宽、高
        const image = new Image();
        image.onload = function () {
          const imgWidth = image.width;
          const imgHeight = image.height;
          // 根据图片大小计算计算压缩质量
          const formatM = localFile.size / 1024 / 1024;
          let quality = 0.7;
          if (formatM < 3 && formatM > 2) {
            quality = 0.98;
          } else if (formatM < 4 && formatM > 3) {
            quality = 0.85;
          } else if (formatM < 5 && formatM > 4) {
            quality = 0.8;
          }
          // 判断是否小于2M
          // 如果大于2M，则进行压缩，反之不用压缩
          const isLt2M = localFile.size / 1024 / 1024 < 2;
          if (!isLt2M) {
            compress(localFile, imgWidth, imgHeight, quality, that.picInfo.type, function (newFile) {
              CusLoadingClose();
              that.picInfo.blob = newFile.blob;
              that.picInfo.small64 = newFile.base64;
              fileCtrl.value = '';
              that.emitGetImgInfo(readerData);
            });
          } else {
            CusLoadingClose();
            fileCtrl.value = '';
            that.emitGetImgInfo(readerData);
          }
        };
        image.src = readerData;
      };
      reader.onerror = function (event) {
        alert('error');
      };
      reader.readAsDataURL(localFile, 'UTF-8');
    },

    // 发起事件
    emitGetImgInfo(base64) {
      this.picInfo.base64 = base64; // 获取图片base64代码
      this.picInfo.fileUrl = document.getElementById('imgLivingUploadFile').value;
      var inter = setInterval(() => {
        if (this.picInfo.base64) {
          // 设置data数据
          this.$emit('getImgInfo', {
            type: this.picInfo.type,
            blob: this.picInfo.blob,
            base64: this.picInfo.base64,
            small64: this.picInfo.small64,
            fileUrl: this.picInfo.fileUrl,
            webUrl: '',
          });
          clearInterval(inter);
        }
      }, 100);
    },

    // 静默活体识别开始
    startBaiduV3Faceverify(imgUrl) {
      const that = this;
      that.recordThridSpendLog(7, () => {
        const url = `https://aip.baidubce.com/rest/2.0/face/v3/faceverify?access_token=${that.livingFaceAccessToken}`;
        const data = JSON.stringify([{ image: imgUrl, image_type: 'URL' }]);
        that.$axios
          .post(url, data, { headers: { 'Content-Type': 'application/json' } })
          .then(res => {
            CusLoadingClose();
            if (res.data.error_code === 0) {
              const score = res.data.result.face_liveness; // 活体分数
              const thresholds = res.data.result.thresholds['frr_1e-3']; // 活体阈值
              const condition1 = score > thresholds; // 合格条件1：活体分数大于阈值，合格
              if (condition1) {
                that.setLivingFaceImgUrl(imgUrl);
                that.setLivingFaceType(2);
              } else {
                if (!condition1) {
                  CusAlert(`分数:${score}，阈值:${thresholds}<br />分数小于阈值，不合格<br />请重新拍照`);
                }
              }
            } else {
              that.showFaceFailInfo(res.data.error_code);
            }
          })
          .catch(() => {
            CusLoadingClose();
            that.setLivingFaceImgUrl('living face error');
          });
      });
    },

    showFaceFailInfo(errCode) {
      let content = '';
      switch (errCode) {
        case 216430:
          content = 'rtse/face 服务异常，请重新拍摄照片';
          break;
        case 216431:
          content = '语音识别服务异常，请重新拍摄照片';
          break;
        case 216432:
          content = '视频解析服务调用失败，请重新拍摄照片';
          break;
        case 216433:
          content = '视频解析服务发生错误，请重新拍摄照片';
          break;
        case 216434:
          content = '活体检测失败，请重新拍摄照片';
          break;
        case 216500:
          content = '验证码位数错误，请重新拍摄照片';
          break;
        case 216501:
          content = '没有找到人脸，请重新拍摄照片';
          break;
        case 216502:
          content = '当前会话已失效，请重新拍摄照片';
          break;
        case 216505:
          content = 'redis连接失败，请重新拍摄照片';
          break;
        case 216506:
          content = 'redis操作失败，请重新拍摄照片';
          break;
        case 216507:
          content = '视频中有多张人脸，请重新拍摄照片';
          break;
        case 216508:
          content = '没有找到视频信息，请重新拍摄照片';
          break;
        case 216509:
          content = '视频中的声音无法识别，请重新拍摄照片';
          break;
        case 216908:
          content = '视频中人脸质量过低，请重新拍摄照片';
          break;
        case 222027:
          content = '验证码长度错误，请重新拍摄照片';
          break;
        case 222028:
          content = '参数格式错误，请重新拍摄照片';
          break;
        case 222029:
          content = '参数格式错误，请重新拍摄照片';
          break;
        case 222030:
          content = '参数格式错误，请重新拍摄照片';
          break;
        default:
          content = `错误，错误码${errCode}，请重新拍摄照片`;
          break;
      }
      CusAlert(content);
    },
  },
};
</script>
